import React, {useState} from 'react';
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { Outlet} from "react-router-dom";
import {logoutUser} from "../../redux/auth/authSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";


const DashboardLayout = ()=>{
    const dispatch = useAppDispatch();
    const [showSideBar, setShowSideBar] = useState(false);
    const toggleShowSidebar = () => setShowSideBar(!showSideBar);
    const { user }  = useAppSelector(state=>state.auth)

    const closeSideBar = ()=>setShowSideBar(false);
    const logout = ()=>{
        closeSideBar();
        dispatch(logoutUser());
    }

    return (
        <React.Fragment>
            <div className="dashboard-layout">
                <Sidebar
                    showSideBar={showSideBar}
                    user={user}
                    closeSideBar={closeSideBar}
                    logout={logout}
                />
                <div className="dashboard-main">
                    <Navbar
                        toggleShowSidebar={toggleShowSidebar}
                        user={user}
                        logout={logout}
                    />
                    <div className="dashboard-page-item">
                        <Outlet />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default DashboardLayout;